<template>
  <div class="form-edit-page">

    <!-- HEADER PROCESSO -->
    <div class="form-header">
      <h2>Fluxo do Processo</h2>
      <div class="row">
        <div class="field">
          <label>Nº Processo</label>
          <input value="2026/000123" disabled />
        </div>

        <div class="field">
          <label>Tipo</label>
          <input value="Registro de Estabelecimento" disabled />
        </div>

        <div class="field">
          <label>Status Atual</label>
          <input value="Vistoria Realizada" disabled />
        </div>
      </div>
    </div>

    <!-- FLUXO VISUAL -->
    <div class="workflow">
      <div
        v-for="(etapa, index) in etapas"
        :key="index"
        class="workflow-step"
        :class="{
          done: etapa.status === 'done',
          current: etapa.status === 'current'
        }"
      >
        <div class="circle">{{ index + 1 }}</div>
        <div class="label">{{ etapa.nome }}</div>
      </div>
    </div>

    <!-- AÇÕES -->
    <div class="form-actions">
      <button @click="avancarEtapa">Avançar Etapa</button>
      <button @click="registrarOcorrencia">Registrar Observação</button>
    </div>

    <!-- HISTÓRICO -->
    <div class="form-list">
      <h3>Histórico do Processo</h3>

      <table>
        <thead>
          <tr>
            <th>Data</th>
            <th>Etapa</th>
            <th>Usuário</th>
            <th>Observação</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(h, i) in historico" :key="i">
            <td>{{ h.data }}</td>
            <td>{{ h.etapa }}</td>
            <td>{{ h.usuario }}</td>
            <td>{{ h.obs }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script setup>
import { ref } from 'vue'

const etapas = ref([
  { nome: 'Solicitação', status: 'done' },
  { nome: 'Análise Documental', status: 'done' },
  { nome: 'Vistoria', status: 'current' },
  { nome: 'Aprovação', status: 'pending' },
  { nome: 'Registro', status: 'pending' }
])

const historico = ref([
  {
    data: '01/03/2026 10:15',
    etapa: 'Solicitação',
    usuario: 'Empresa',
    obs: 'Processo iniciado'
  },
  {
    data: '02/03/2026 14:20',
    etapa: 'Análise Documental',
    usuario: 'Fiscal João',
    obs: 'Documentos aprovados'
  },
  {
    data: '05/03/2026 09:00',
    etapa: 'Vistoria',
    usuario: 'Fiscal Maria',
    obs: 'Vistoria realizada sem não conformidades'
  }
])

function avancarEtapa() {
  alert('Aqui você vai integrar com a API para mudar a etapa')
}

function registrarOcorrencia() {
  alert('Abrir modal para observação / anexo / assinatura')
}
</script>

<style scoped>
.workflow {
  display: flex;
  gap: 20px;
  margin: 20px 0;
}

.workflow-step {
  text-align: center;
}

.circle {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: #ccc;
  line-height: 35px;
  color: #fff;
}

.workflow-step.done .circle {
  background: #28a745;
}

.workflow-step.current .circle {
  background: #007bff;
}

.label {
  margin-top: 5px;
  font-size: 12px;
}
</style>